import { sql } from 'drizzle-orm'

export const migrate0002 = sql`CREATE TABLE \`sync\` (
	\`key\` text PRIMARY KEY NOT NULL,
	\`timestamp\` integer NOT NULL
);
--> statement-breakpoint
ALTER TABLE \`actionSource\` ADD \`evmFrom\` blob;--> statement-breakpoint
ALTER TABLE \`actionSource\` ADD \`evmTo\` blob;`
